import React, { useState } from 'react';
import { API_BASE } from '../api/config';
import './WarehouseShopAccessPanel.css';

const routes = { AYMHT: ['GMP', 'JS', 'MT', 'JCHT', 'MDYHT'], AYMPF: ['JCPF', 'MDYPF'] };

export default function WarehouseShopAccessPanel({ user, selectedLocation }) {
  const role = String(user?.role || '').toUpperCase();
  const shops = routes[selectedLocation] || (['ADMIN', 'OFFICE'].includes(role) ? [...routes.AYMHT, ...routes.AYMPF] : []);
  const [shop, setShop] = useState('');
  const [issued, setIssued] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  if (!['ADMIN', 'OFFICE', 'WAREHOUSE_MANAGER'].includes(role)) return null;

  async function issue(event) {
    event.preventDefault();
    if (!shop || !shops.includes(shop) || busy) return;
    if (!window.confirm(`${shop} အတွက် Transfer Access Code အသစ်ထုတ်မလား? အဟောင်းကို အသစ် login တွင် မသုံးနိုင်တော့ပါ။`)) return;
    setBusy(true); setError(''); setIssued(null);
    try {
      const response = await fetch(`${API_BASE}/api/erp/warehouse/transfer-auth/shop-code`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('erpWarehouseTransferToken') || ''}` },
        body: JSON.stringify({ shop }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || !data.success) throw new Error(data.message || 'Access code could not be issued.');
      setIssued(data);
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  }

  return <details className="warehouseShopAccess">
    <summary>Shop POS transfer access</summary>
    <p>WS က ဆိုင်တစ်ဆိုင်ချင်း access code တစ်ကြိမ် ထုတ်ပေးပြီး ဆိုင် POS login မှာ ထည့်စေပါ။ Code ကို ဒီနေရာမှာ တစ်ကြိမ်ပဲ ပြမယ်။</p>
    <form onSubmit={issue}>
      <select aria-label="Shop" value={shop} onChange={event => { setShop(event.target.value); setIssued(null); }} required>
        <option value="">Select shop</option>{shops.map(value => <option key={value} value={value}>{value}</option>)}
      </select>
      <button disabled={!shop || busy} type="submit">{busy ? 'Issuing…' : 'Issue / rotate code'}</button>
    </form>
    {error && <p className="warehouseShopAccess__error" role="alert">{error}</p>}
    {issued && <div className="warehouseShopAccess__code"><b>{issued.shop}</b><code>{issued.accessCode}</code><button type="button" onClick={() => navigator.clipboard.writeText(issued.accessCode)}>Copy code</button><small>ဤ code ကို ဆိုင်တာဝန်ခံထံ သီးသန့်ပေးပါ။ Page refresh လုပ်ပြီးရင် ပြန်မမြင်ရပါ။</small></div>}
  </details>;
}
